import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import CampaignCardList from 'component/common/CampaignCardList';
import HomeBanner from 'component/home/HomeBanner';
import OnlyForYouMobile from 'component/home/OnlyForYouMobile';
import OnlyForYouWeb from 'component/home/OnlyForYouWeb';
import OfferFloatActionButton from 'component/offer/OfferFloatActionButton';

import { createAction } from 'utils';
import ServerConfig from 'utils/ServerConfig';
import { inMiniProgram } from 'utils/WeChatUtil';

import './Home.scss';
import SignUpBanner from '../component/home/SignUpBanner';
import PointToCashBanner from '../component/home/PointToCashBanner';

@connect(({ campaignList, users }) => ({ ...campaignList, users: users }))
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.isInMiniProgram = inMiniProgram();
  }

  componentDidMount() {
    if (this.props.users.isLogin) {
      this.props.dispatch(
        createAction('campaignList/homeOnlyForYouListRefresh')({}),
      );
    }
    this.props.dispatch(
      createAction('campaignList/homeFeatureListRefresh')({}),
    );
    this.props.dispatch(createAction('campaignList/homeBannnerRefresh')({}));
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.users.isLogin === true &&
      prevProps.users.isLogin === false
    ) {
      this.props.dispatch(
        createAction('campaignList/homeOnlyForYouListRefresh')({}),
      );
    }

    if (
      this.props.users.isLogin &&
      this.props.users.language !== prevProps.users.language
    ) {
      this.props.dispatch(
        createAction('campaignList/homeOnlyForYouListRefresh')({}),
      );
    }
    if (this.props.users.language !== prevProps.users.language) {
      this.props.dispatch(createAction('campaignList/homeBannnerRefresh')({}));
    }
  }

  onlyForYouSection = () => {
    if (ServerConfig.getNoOnlyForYouCampaign()) {
      return null;
    }
    if (this.props.users.isLogin && this.props.homeOnlyForYouList.length > 0) {
      return (
        <div
          className={`home_only_for_you_section ${
            this.props.homeBanner?.length > 0 ? '' : 'no-banner'
          }`}
        >
          <OnlyForYouWeb
            pageName="home"
            categoryName="ONLYFORYOU"
            categoryId={null}
            data={this.props.homeOnlyForYouList}
          />
          <OnlyForYouMobile
            pageName="home"
            categoryName="ONLYFORYOU"
            categoryId={null}
            data={this.props.homeOnlyForYouList}
          />
        </div>
      );
    }
  };

  render() {
    return (
      <div className="home_page">
        <SignUpBanner />
        <PointToCashBanner />
        {this.props.homeBanner?.length > 0 && <HomeBanner />}
        <div className="home_onboard_container">
          <Container className="home_container">
            {this.onlyForYouSection()}
          </Container>
        </div>
        <Container className="home_container">
          <Container className="home_card_container">
            <div className="home_title_container" onClick={this._login}>
              {this.props.t('feature')}
            </div>
            <CampaignCardList
              pageName="home"
              categoryName="FEATURE"
              categoryId={null}
              data={this.props.homeFeatureList}
            />
            <OfferFloatActionButton />
          </Container>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Home);
